import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "Dashboard": "Dashboard",
      "Home": "Home",
      "Contests": "Contests",
      "Problems": "Problems",
      "Standings": "Standings",
      "Login": "Login",
      "Register": "Register",
      "Logout": "Logout",
      "Welcome": "Welcome",
      "Profile": "Profile",
      "Language": "Language",
      "English": "English",
      "Vietnamese": "Tiếng Việt",
      "My Submissions": "My Submissions",
      "Groups": "Groups",
      "Teacher": "Teacher",
      "Admin": "Admin",
      "Problem": "Problem",
      "Results": "Results",
      "Description": "Description",
      "Input": "Input Format",
      "Output": "Output Format",
      "Constraints": "Constraints",
      "Sample": "Sample",
      "Examples": "Examples",
      "Example": "Example",
      "Notes": "Notes",
      "Teacher's Solution": "Teacher's Solution",
      "Shared by your teacher ·": "Shared by your teacher ·",
      "Updated:": "Updated:",
      "Explanation": "Explanation",
      "Code": "Code",
      "No teacher solution available for this problem.": "No teacher solution available for this problem.",
      "Time Limit": "Time Limit",
      "Memory Limit": "Memory Limit",
      "Active Group:": "Active Group:",
      "View All": "View All",
      "Whiteboard & solutions scoped to group": "Whiteboard & solutions scoped to group",
      "Select a group to use the whiteboard or share solutions": "Select a group to use the whiteboard or share solutions",
      "Tags": "Tags",
      "Hint": "Hint",
      "Solution": "Solution",
      "Run Code": "Run Code",
      "Submit Code": "Submit",
      "Language:": "Language:",
      "Theme:": "Theme:"
    }
  },
  vi: {
    translation: {
      "Dashboard": "Trang chủ",
      "Home": "Trang chủ",
      "Contests": "Kỳ thi",
      "Problems": "Bài tập",
      "Standings": "Bảng xếp hạng",
      "Login": "Đăng nhập",
      "Register": "Đăng ký",
      "Logout": "Đăng xuất",
      "Welcome": "Chào mừng",
      "Profile": "Hồ sơ",
      "Language": "Ngôn ngữ",
      "English": "English",
      "Vietnamese": "Tiếng Việt",
      "My Submissions": "Bài nộp của tôi",
      "Groups": "Nhóm",
      "Teacher": "Giáo viên",
      "Admin": "Quản trị",
      "Problem": "Đề bài",
      "Results": "Kết quả",
      "Description": "Mô tả",
      "Input": "Định dạng đầu vào",
      "Output": "Định dạng đầu ra",
      "Constraints": "Ràng buộc",
      "Sample": "Ví dụ",
      "Examples": "Các ví dụ",
      "Example": "Ví dụ",
      "Notes": "Ghi chú",
      "Teacher's Solution": "Lời giải của giáo viên",
      "Shared by your teacher ·": "Chia sẻ bởi giáo viên ·",
      "Updated:": "Cập nhật lúc:",
      "Explanation": "Giải thích",
      "Code": "Mã nguồn",
      "No teacher solution available for this problem.": "Chưa có lời giải nào từ giáo viên cho bài này.",
      "Time Limit": "Giới hạn thời gian",
    "Match": "Khớp",
    "Mismatch": "Không khớp",
    "Compilation Error": "Lỗi biên dịch",
    "Your Output:": "Đầu ra của bạn:",
    "Input:": "Đầu vào:",
    "Expected:": "Kết quả mong đợi:",
    "OK": "Thành công (OK)",
    "TLE": "Quá thời gian (TLE)",
    "Runtime Error": "Lỗi thực thi",
    "Error": "Lỗi",
    "Custom Test": "Thử nghiệm tuỳ chỉnh",
    "Status:": "Trạng thái:",
    "No submissions yet for this problem.": "Chưa có bài nộp nào cho bài tập này.",
    "latest": "mới nhất",
    "Share Solution with Students": "Chia sẻ giải pháp với học sinh",
    "Write your solution in the editor, then click Share.": "Viết giải pháp của bạn trên trình soạn thảo, sau đó nhấp vào Chia sẻ.",
    "Only students in the active group will see it.": "Chỉ học sinh trong nhóm đang hoạt động mới nhìn thấy.",
    "Explanation (Markdown supported)": "Giải thích (Hỗ trợ Markdown)",
    "Write an explanation for the solution... Supports **bold**, `inline code`, numbered lists, etc.": "Viết giải thích cho giải pháp... Hỗ trợ **in đậm**, `mã nội tuyến (inline code)`, danh sách đánh số v.v.",
    "Sharing...": "Đang chia sẻ...",
    "📤 Share Solution": "📤 Chia sẻ giải pháp",
    "Remove shared solution": "Gỡ bỏ giải pháp đã chia sẻ",
    "Currently shared for": "Đang chia sẻ cho",
    "Updated:": "Đã cập nhật:",
    "Explanation preview:": "Xem trước giải thích:",
    "No solution shared yet for this code. Write code in the editor and click Share.": "Chưa có giải pháp nào được chia sẻ. Viết mã và nhấp vào Chia sẻ.",
    "✕ Custom Input": "✕ Đóng đầu vào",
    "⌨ Custom Input": "⌨ Đầu vào tuỳ chỉnh",
    "Select a group to use the whiteboard": "Chọn nhóm để dùng bảng trắng",
    "✕ Whiteboard": "✕ Đóng bảng trắng",
    "🖊 Whiteboard": "🖊 Bảng trắng",
    "Running...": "Đang chạy...",
    "▶ Run Custom": "▶ Chạy tuỳ chỉnh",
    "▶ Run Sample": "▶ Chạy mẫu",
    "Submitting...": "Đang nộp bài...",
    "📤 Submit": "📤 Nộp bài",
    "Custom Input": "Đầu vào tuỳ chỉnh",
    "Enter your test input here...": "Nhập đầu vào cho thử nghiệm ở đây...",
    "Expected Output": "Đầu ra mong đợi",
    "optional": "không bắt buộc",
    "Expected output (for comparison)...": "Đầu ra mong đợi (để đối chiếu)...",
      "Memory Limit": "Giới hạn bộ nhớ",
      "Active Group:": "Nhóm hiện tại:",
      "View All": "Xem tất cả",
      "Whiteboard & solutions scoped to group": "Bảng trắng & lời giải áp dụng cho nhóm",
      "Select a group to use the whiteboard or share solutions": "Chọn một nhóm để sử dụng bảng trắng hoặc chia sẻ lời giải",
      "Tags": "Thẻ",
      "Hint": "Gợi ý",
      "Solution": "Lời giải",
      "Run Code": "Chạy thử",
      "Submit Code": "Nộp bài",
      "Language:": "Ngôn ngữ:",
      "Theme:": "Giao diện:"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;
